import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconAudioNextComponent } from "./med-icon-audio-next.component";

@NgModule({
  declarations: [
    MedIconAudioNextComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconAudioNextComponent,
  ],
})
export class MedIconAudioNextModule { }
